<template>
    <div>
        {{selected_part_program_id}}
        <v-row justify="start">
            <v-col cols="12" align="left">
                <v-badge color="white" >
                    <h3 style="text-align:left" >Gestione part program macchinario</h3>
                    <template v-slot:badge >
                        <v-progress-circular indeterminate color="indigo" size="12" width="2" v-if="ui.loading" />
                    </template>
                </v-badge>
            </v-col>
        </v-row>        
        <v-row align="center" v-if="machine_programs!=null&&!(ui.disabled_machine||ui.disabled_phase)">
            <v-col cols="5">
                <v-select :items="machine_programs" item-text="name" item-value="id" label="Part program macchina" v-model="selected_part_program_id" @change="selectPartProgram"/>
            </v-col>
            <v-col cols="1" v-if="getValidId(selected_part_program_id)">
                <v-btn icon @click="editPartProgramValues">
                    <v-icon color="indigo">mdi-square-edit-outline</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="6">
                <!--{{associated_part_program}}-->
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col cols="12" align="left" v-if="!ui.loading">
                {{ui.disabled_machine? ui.disabled_machine_message : ui.disabled_phase_message}}
            </v-col>
        </v-row>
    </div>
    
</template>
<script>
export default {
    name:'PartProgramConfig',
    props : {
        is_article : Boolean,
        selected_machine_id : [Number, String],
        machine_phase : Object
    },
    data(){
        return{
            associated_part_program : null,
            machine_phase_id : null,
            machine_programs : null,
            selected_part_program_id : null,
            ui : {
                disabled_machine : false,
                disabled_machine_message : null,
                loading_machine : false,
                disabled_phase : false,
                disabled_phase_message : null,
            }
        }
    },
    watch : {
        machine_phase : {
            immediate : true,
            handler(value){
                const machine_phase_id = this.getValidId(value.idciclo_fasi_macchina);
                const disable_status = {};
                if(machine_phase_id){
                    this.machine_phase_id = machine_phase_id;
                    this.getAssociatedPartProgram(machine_phase_id);
                    disable_status.disabled_phase = false;
                    disable_status.disabled_phase_message = null;
                }else{
                    disable_status.disabled_phase = true;
                    disable_status.disabled_phase_message = 'Funzionalità non disponibile per macchine non registrate sulla fase corrente.';
                }
                Object.assign(this.ui, disable_status);
            }
        },
        selected_machine_id : {
            immediate : true,
            handler(value){
                const machine_id = this.getValidId(value);
                const disable_status = {};
                if(machine_id){
                    this.getPartProgramsMacchina(machine_id);
                    disable_status.disabled_machine = false;
                    disable_status.disabled_machine_message = null;
                }else{
                    disable_status.disabled_machine = true;
                    disable_status.disabled_machine_message = 'Il macchinario selezionato non è valido.';
                }
                Object.assign(this.ui, disable_status);                
            }
        }
    },
    methods : {
        editPartProgramValues(){
            console.log("editPartProgramValues");
            this.$emit("editPartProgramValues");
        },
        getAssociatedPartProgram() {            
            const request = {
                controller: 'quickconnext',
                method: 'POST',
                richiesta: {
                    action: 'getassociatedpartprogram',
                    token: localStorage.user_token,
                    id_ciclo_fasi_macchina: this.machine_phase_id,
                    call_type: this.is_article ? 1 : 2,
                },
            };
            this.$store.dispatch('connext', request).then((res) => {
                if (res.data.associated_part_program == null) {
                    console.log('null', res.data);
                    this.resetAssociatedPartProgram();
                } else {
                    this.associated_part_program = res.data.associated_part_program[0];
                    try{
                        this.associated_part_program.dettaglio_part_program = JSON.parse(decodeURIComponent(escape(atob(this.associated_part_program.dettaglio_part_program))));
                    }catch{
                        this.associated_part_program.dettaglio_part_program = null;
                    }
                }
                this.selected_part_program_id = this.associated_part_program.dettaglio_part_program ? this.associated_part_program.dettaglio_part_program.id : null;
            });
        },
        getPartProgramsMacchina(machine_id) { 
            this.machine_programs = null;
            this.resetAssociatedPartProgram();
            this.ui.loading = true;
            const request = {
                controller: 'quickconnext',
                method: 'POST',
                richiesta: {
                    action: 'getmachineprogramparameters',
                    token: localStorage.user_token,
                    id_macchina: machine_id,
                },
            };
            this.$store.dispatch('connext', request).then((res) => {
                this.machine_programs = res.data;
                this.ui.loading = false;
            }).catch(() => {
                this.ui.loading = false;
            });
        },
        getValidId(input){
            const id = Number(input);
            if(input == null || !isFinite(id) || id <= 0){ 
                return false;
            }
            return id;
        },
        resetAssociatedPartProgram() {
            this.selected_part_program_id = null;
            this.associated_part_program = {
                id_articolo_dettaglio_4_0: !this.is_article ? undefined : -1,
                id_commessa_dettaglio_4_0: this.is_article ? undefined : -1,
                id_ciclo_fasi_macchina: this.machine_phase_id,
                dettaglio_part_program: null,
                validita: 1,
            };
        },
        savePartProgram(){
            const program = JSON.parse(JSON.stringify(this.associated_part_program));
            program.dettaglio_part_program = btoa(unescape(encodeURIComponent(JSON.stringify(program.dettaglio_part_program))));
            const request = {
                controller: 'quickconnext',
                method: 'PUT',
                richiesta: {
                    action: 'associatepartprogram',
                    token: localStorage.user_token,
                    id_macchina: this.selected_machine_id,
                    call_type: this.is_article ? 1 : 2,
                    associated_part_program: [program],
                },
            };
            this.$store.dispatch('connext', request).then((res) => {
                console.log(res.data);
            });
        },
        selectPartProgram(id){
            if(!(id = this.getValidId(id))){ return; }
            for(let i=0; i < this.machine_programs.length; i++){
                const machine_program = this.machine_programs[i];
                if(machine_program.id == id){
                    this.associated_part_program.dettaglio_part_program = JSON.parse(JSON.stringify(machine_program));
                    return;
                }
            }
        }
    }
}
</script>